<template>
  <offices-search
    :metro="filter.metro"
    :how="filter.how"
    :minCost="filter.minCost"
    :maxCost="filter.maxCost"
    :minSquareMeter="filter.minSquareMeter"
    :maxSquareMeter="filter.maxSquareMeter"
    :available="filter.available"
    :type="filter.type"
    :classOffice="filter.classOffice"
    @newSearch="updateGetObjects"
  />

  <div v-for="item in office.objects" :key="item.id">
    <offices-card :object="item"/>
  </div>

  <pagination
    :number="10"
    :page="filter.page"
    :total="office.total"
    @newPagination="updatePage"
  />
</template>

<script>
import Pagination from "@/components/UI/Pagination.vue";
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref, computed} from "vue";
import OfficesSearch from "@/components/pages/commercial/OfficesSearch.vue";
import useOffices from "@/hooks/useOffices";
import OfficesCard from "@/components/pages/commercial/OfficesCard.vue";
import {useHead} from "@unhead/vue";

export default {
  name: "offices",
  components: {OfficesCard, OfficesSearch, Pagination},
  setup() {
    const route = useRoute()
    const router = useRouter()
    const {getOffices, office} = useOffices()

    // Функция для очистки URL от пустых параметров
    const cleanQuery = () => {
      const query = {}
      if (filter.value.metro) query.metro = filter.value.metro
      if (filter.value.how) query.how = filter.value.how
      if (filter.value.minCost) query.minCost = filter.value.minCost
      if (filter.value.maxCost) query.maxCost = filter.value.maxCost
      if (filter.value.minSquareMeter) query.minSquareMeter = filter.value.minSquareMeter
      if (filter.value.maxSquareMeter) query.maxSquareMeter = filter.value.maxSquareMeter
      if (filter.value.type) query.type = filter.value.type
      if (filter.value.classOffice) query.classOffice = filter.value.classOffice
      if (filter.value.page > 1) query.page = filter.value.page
      return query
    }

    // Метатеги
    const pageTitle = "Офисы в аренду и продажу | P-L-E.ru"
    const pageDescription = "Актуальные предложения по аренде и продаже офисов в Москве. Подбор по метро, цене и площади."
    const canonicalUrl = computed(() => `https://p-l-e.ru/offices`)

    useHead({
      title: pageTitle,
      meta: [
        { name: 'description', content: pageDescription },
        { property: 'og:title', content: pageTitle },
        { property: 'og:description', content: pageDescription },
        { property: 'og:url', content: canonicalUrl },
        { property: 'og:type', content: 'website' }
      ],
      link: [
        { rel: 'canonical', href: canonicalUrl }
      ]
    })

    const filter = ref({
      region: route.query.region || "",
      metro: route.query.metro || "",
      how: route.query.how || "",
      minCost: route.query.minCost || "",
      maxCost: route.query.maxCost || "",
      minSquareMeter: route.query.minSquareMeter || "",
      maxSquareMeter: route.query.maxSquareMeter || "",
      page: Number(route.query.page) || 1,
      type: route.query.type || "",
      classOffice: route.query.classOffice || "",
    })

    onMounted(async () => {
      await router.replace({ query: cleanQuery() })
      await getOffices()
    })

    const updatePage = async (page) => {
      filter.value.page = page
      await router.replace({ query: cleanQuery() })
      await getOffices()
    }

    const updateGetObjects = async (
      metro,
      how,
      minCost,
      maxCost,
      minSquareMeter,
      maxSquareMeter,
      type,
      classOffice
    ) => {
      filter.value.metro = metro
      filter.value.how = how
      filter.value.minCost = minCost
      filter.value.maxCost = maxCost
      filter.value.minSquareMeter = minSquareMeter
      filter.value.maxSquareMeter = maxSquareMeter
      filter.value.type = type
      filter.value.classOffice = classOffice
      filter.value.page = 1

      await router.replace({ query: cleanQuery() })
      await getOffices()
    }

    return {updateGetObjects, updatePage, office, filter}
  }
}
</script>

<style scoped>
/* Ваши стили остаются без изменений */
</style>